module.exports = __webpack_public_path__ + "img/商家资质.fbdc3989.png";